import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { EnvironmentProviders, makeEnvironmentProviders, NgModule } from '@angular/core';

import { PermissionsService } from './permissions.service';
import { MsalAuthModule, msalAuthProviders } from './msal';
import { MobileAuthService } from './mobile-auth.service';
import { KeycloakAuthModule, keycloakAuthProviders } from './keycloak';
import { AuthService } from './auth.types';
import { AuthContext, HostUriFactory } from './auth.helpers';
import {
  ISS_AUTH_GUARD,
  ISS_AUTH_SERVICE,
  ISS_HOST_URI,
  ISS_LOGOUT_URI,
  ISS_REDIRECT_URI,
} from './auth.config';

export function noAuthProviders(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ISS_AUTH_GUARD,
      useFactory: (router: Router) => () => router.createUrlTree([ 'login' ], {
        queryParams: {
          redirect: window.location.href,
        },
      }),
      deps: [ Router ],
    },
    {
      provide: ISS_AUTH_SERVICE,
      useClass: class implements AuthService {
        public bootstrap(): Observable<unknown> {
          return of(undefined);
        }

        public logout(): Observable<unknown> {
          return of(undefined);
        }

        public isLoggedIn(): Observable<boolean> {
          return of(false);
        }
      },
    },
  ]);
}

@NgModule({
  imports: [
    MsalAuthModule,
    KeycloakAuthModule,
  ],
  providers: [
    PermissionsService,
    MobileAuthService,
    AuthContext.isInternalUser() ? msalAuthProviders() : AuthContext.isExternalUser() ? keycloakAuthProviders() : noAuthProviders(),
    {
      provide: ISS_REDIRECT_URI,
      useFactory: (hostUri: string) => `${ hostUri }/authorize`,
      deps: [ ISS_HOST_URI ],
    },
    {
      provide: ISS_LOGOUT_URI,
      useFactory: (hostUri: string) => `${ hostUri }/logout`,
      deps: [ ISS_HOST_URI ],
    },
    {
      provide: ISS_HOST_URI,
      useFactory: HostUriFactory,
    },
  ],
})
export class AuthModule {}
